import { DataType } from 'src/app/common/models/enums/common.enum';
import { ReportTableColumn, ReportTableDropdown } from 'src/app/reports/components/reports-lists/models/reports.model';

export class rentUnitSizeWiseConstant {
  static rentUnitSizeWiseTableColumn: ReportTableColumn[] = [
    {
      header: 'unit_size',
      columnName: 'reports.unit_size',
      field: 'unit_size',
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      symbol: DataType.squareMeter,
    },
    {
      header: 'all_floor_range',
      columnName: 'reports.all_floor',
      field: 'all_floor_range',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'all_floor_avg',
    },
    {
      header: 'lower_ground_range',
      columnName: 'reports.lower_ground',
      field: 'lower_ground_range',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'lower_ground_avg',
    },

    {
      header: 'ground_range',
      columnName: 'reports.ground',
      field: 'ground_range',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'ground_avg',
    },
    {
      header: `first_floor_range`,
      columnName: `1Floor`,
      field: `first_floor_range`,
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'first_floor_avg',
    },
    {
      header: `second_floor_range`,
      columnName: `2Floor`,
      field: `second_floor_range`,
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'second_floor_avg',
    },
    {
      header: `third_floor_range`,
      columnName: `3Floor`,
      field: `third_floor_range`,
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'third_floor_avg',
    },
    {
      header: `higher_floor_range`,
      columnName: `higherFloor`,
      field: `higher_floor_range`,
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'higher_floor_avg',
    },
  ];

  static rentUnitSizeWiseTableColumnAvg: ReportTableColumn[] = [
    {
      header: 'unit_size',
      columnName: 'reports.unit_size',
      field: 'unit_size',
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      symbol: DataType.squareMeter,
    },
    {
      header: 'all_floor_avg',
      columnName: 'reports.all_floor',
      field: 'all_floor_avg',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'all_floor_range',
    },
    {
      header: 'lower_ground_avg',
      columnName: 'reports.lower_ground',
      field: 'lower_ground_avg',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'lower_ground_range',
    },

    {
      header: 'ground_avg',
      columnName: 'reports.ground',
      field: 'ground_avg',
      symbol: DataType.currencyWithSquareMeter,
      isSortable: false,
      border: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField:'ground_range',
    },
    {
      header: `first_floor_avg`,
      columnName: `1Floor`,
      field: `first_floor_avg`,
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: `first_floor_range`,
    },
    {
      header: `second_floor_avg`,
      columnName: `2Floor`,
      field: `second_floor_avg`,
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'second_floor_range',
    },
    {
      header: `third_floor_avg`,
      columnName: `3Floor`,
      field: `third_floor_avg`,
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'third_floor_range',
    },
    {
      header: `higher_floor_avg`,
      columnName: `higherFloor`,
      field: `higher_floor_avg`,
      symbol: DataType.currencyWithSquareMeter,
      border: false,
      isSortable: false,
      isContainsHTML: false,
      convertNumber: false,
      toolTipField: 'higher_floor_range',
    },
  ];

  static rentUnitSizeDropdown: ReportTableDropdown = {
    label: 'reports.show_price_in',
    data: [
      {
        value: 'Range',
        id: 'Range',
      },
      {
        value: 'Average',
        id: 'Average',
      },
    ],
    default: 'Range',
    maxSelect: 1,
    reportType: false,
  };
}
